import { motion, useTransform, transform } from "framer-motion"
import styled from "@emotion/styled"

import { useViewport } from "contexts/Viewport"
import useSSR from "hooks/useSSR"

const Div = styled(motion.div, {
  shouldForwardProp: prop => prop !== "contained",
})`
  display: block;
  width: 100%;
  height: 100.1%;
  background: rgb(0 0 0);
  grid-row: fullh;
  grid-column: doc;
  z-index: -1;
  transform: translate3d(0, 0, 0);

  ${({ contained }) =>
    contained
      ? `
    position: absolute;
    inset: 0;
    height: auto;
    grid-row: auto;
    grid-column: auto;
    z-index: 1;
    pointer-events: none;
  `
      : ""}
`

export default function Overlay({ prog, doubled, contained }) {
  const ssr = useSSR()
  const { height } = useViewport()

  const opacity = useTransform([prog, height], ([p, h]) => {
    if (ssr) return 0
    return transform(p, doubled ? [0, h] : [0, h * 0.75], [0.1, 0.8])
  })

  return <Div contained={contained} style={{ opacity }} />
}
